/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

setInterval(function () {
  
  if($(document).find('.boost-pfs-search-suggestion-product-title').length){
    $(document).find('.boost-pfs-search-suggestion-product-title').each(function(){
      var findTitle = $(this).text();
      if(findTitle.indexOf("SPECIAL OFFER") != -1){
        $(this).parents('.boost-pfs-search-suggestion-item').remove();
      }
      
      if(findTitle.indexOf("Special Offer") != -1){
        $(this).parents('.boost-pfs-search-suggestion-item').remove();
      }
      
    });
  }
  
  
  
  if($(document).find('.boost-pfs-filter-products').length){
    $(document).find('.ProductItem__Title.Heading a').each(function(){
      var findTitle = $(this).text();
      if(findTitle.indexOf("SPECIAL OFFER") != -1){
        $(this).parents('.Grid__Cell').remove();
      }
      if(findTitle.indexOf("Special Offer") != -1){
        $(this).parents('.Grid__Cell').remove();
      }
    });
  }

  if(!$(document).find('.custom-checkout--btn.checkout--button').length){
    $(document).find('.satcb-cs-checkout-btn').after('<span class="custom-checkout--btn checkout--button">Checkout</span>');
  }
  
}, 10);

$(document).ready(function(){
  $(document).on('change','.custom__attributes',function(){
    if(!$(this).is(':checked')){
      // $(this).prop('checked',false);
    }else{
      //$(document).find('.custom__attributes').prop('checked',false);
      $(this).prop('checked',true);
    }
    if($(document).find('.custom__attributes:checked').length){
      var checkedValue = $(document).find('.custom__attributes:checked').val();
      $(document).find('#custom_checkbox').val(checkedValue);
    }else{
       $(document).find('#custom_checkbox').val('');
    }
  });
  $(document).on('click','.custom-checkout--btn',function(event){
    event.preventDefault();
    $(document).find('.cart-attribute--popup,.cart-attribute--popup-overlay').addClass('active');
  });  
  $(document).on('click','.checkout--button',function(){
    var parentElement = $(this).parent('div');
  });
});
